import type { Notification } from '@aroo/shared';
import {
  IconCalendarCheck,
  IconCalendarEvent,
  IconCalendarX,
  IconClipboardCheck,
  IconClockExclamation,
  IconMessageCircle,
  IconSpeakerphone,
  IconStethoscope,
} from '@tabler/icons-react';

/** The icon for a notification kind (the bell's list and the Notifications page). */
export function NotifIcon({ kind }: { kind: Notification['kind'] }) {
  const props = { size: 18, stroke: 2 };
  switch (kind) {
    case 'holiday_approved':
    case 'holiday_booked':
    case 'absence_approved':
      return <IconCalendarCheck {...props} />;
    case 'holiday_declined':
    case 'holiday_cancelled':
    case 'holiday_withdrawn':
    case 'absence_declined':
    case 'absence_withdrawn':
    case 'absence_cancelled':
      return <IconCalendarX {...props} />;
    case 'holiday_nudge':
    case 'holiday_escalation':
    case 'rtw_due':
    case 'fit_note_due':
    case 'absence_rule_hit':
      return <IconClockExclamation {...props} />;
    case 'absence_recorded':
    case 'absence_requested':
      return <IconStethoscope {...props} />;
    case 'oc_escalation':
      return <IconClipboardCheck {...props} />;
    case 'announcement':
      return <IconSpeakerphone {...props} />;
    case 'chat_mention':
    case 'chat_dm':
    case 'chat_thread':
      return <IconMessageCircle {...props} />;
    default:
      return <IconCalendarEvent {...props} />;
  }
}
